import { createContext, useContext, useState, useEffect } from "react";

interface Location {
  id: number;
  name: string;
  isSelected: boolean;
  isVisible: boolean;
  isDisabled: boolean;
}

interface LocationsMenuContextType {
  unityLocations: Location[];
  handleSelectLocation: (id: number) => void;
  toggleVisibility: (id: number) => void;
}

const LocationsMenuContext = createContext<LocationsMenuContextType | null>(null);

export const LocationsMenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const unityLocationsInit: Location[] = [
    { id: 1000, name: "Plant Demo", isSelected: true, isVisible: true, isDisabled: false },
    { id: 1001, name: "Building Demo", isSelected: false, isVisible: true, isDisabled: false },
    { id: 1002, name: "Quarry", isSelected: false, isVisible: true, isDisabled: false },
    { id: 1003, name: "Power Lines", isSelected: false, isVisible: true, isDisabled: false },
    { id: 1004, name: "Construction Site", isSelected: false, isVisible: true, isDisabled: false },
  ];

  const [unityLocations, setUnityLocations] = useState<Location[]>(unityLocationsInit);

  const handleSelectLocation = (id: number) => {
    setUnityLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id
          ? { ...location, isSelected: true }
          : { ...location, isSelected: false }
      )
    );
  };

  const toggleVisibility = (id: number) => {
    setUnityLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id ? { ...location, isVisible: !location.isVisible } : location
      )
    );
  };

  const sendStateToUnity = (method: string, readyArguments: any) => {
    if (window.vuplex) {
      window.vuplex.postMessage(
        JSON.stringify({
          object: "ReactUIManager",
          type: "ReactUIManager",
          method: method,
          arguments: [JSON.stringify(readyArguments)],
        })
      );
    }
  };

  useEffect(() => {
    sendStateToUnity("SetLocationVisibility", [unityLocations]);
  }, [unityLocations]);

  return (
    <LocationsMenuContext.Provider
      value={{ unityLocations, handleSelectLocation, toggleVisibility }}
    >
      {children}
    </LocationsMenuContext.Provider>
  );
};

export const useLocationsMenu = () => {
  const context = useContext(LocationsMenuContext);
  if (!context) {
    throw new Error("useLocationsMenu must be used within a LocationsMenuProvider");
  }
  return context;
};
